<template>
  <div
    class="offcanvas offcanvas-start rounded-end-4 p-4"
    tabindex="-1"
    id="navigation"
    aria-labelledby="navigation"
    navbar
    :class="show ? 'show' : ''"
  >
    <div class="offcanvas-body p-0 d-flex flex-column">
      <div class="d-flex px-4 py-2">
        <small class="offcanvas-title fw-bold" id="navigationHeader"
          >Main</small
        >
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <NavButtonComp
        name="Home"
        icon="ph-bold ph-house-simple"
        :active="true"
      />
      <NavButtonComp name="Applications" icon="ph-bold ph-folder-simple" />
      <NavButtonComp name="Customers" icon="ph-bold ph-users-three" />
      <NavButtonComp name="Vehicles" icon="ph-bold ph-car-simple" />
      <NavButtonComp name="Subscriptions" icon="ph-bold ph-address-book" />
      <NavButtonComp name="Leads" icon="ph-bold ph-identification-card" />
      <NavButtonComp name="Reports" icon="ph ph-note" />
      <div class="pb-5"></div>
      <div class="d-flex px-4 pb-2">
        <small class="offcanvas-title fw-bold" id="navigationHeader"
          >Profile</small
        >
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <NavButtonComp name="Profile" icon="ph-bold ph-user-circle" />
      <NavButtonComp name="Logout" icon="ph-bold ph-sign-out" />
    </div>
  </div>
</template>

<script>
import NavButtonComp from "@/components/navigation/NavButtonComp.vue";

export default {
  name: "NavComp",
  props: {
    show: {
      type: Boolean,
      required: false,
    },
  },
  components: { NavButtonComp },
};
</script>

<style scoped>
[navbar] {
  background-color: var(--futurerent);
  color: white;
}
</style>
